import { v4 } from 'uuid';
import {
  AnyDomainSection,
  AnyServerSection,
  CTA,
  DomainSection,
  SectionBase,
  SectionColor,
  SectionName,
  sectionsConstructorMap,
  ServerCTA,
  ServerSection,
} from './domain';
import { Mapper } from '@client/new/helpers/types';

const sectionColors: SectionColor[] = [
  'primaryColor',
  'secondaryColor',
  'tertiaryColor',
];

export const toCTA: Mapper<ServerCTA, CTA> = (cta) => ({
  enabled: cta?.enabled ?? false,
  text: cta?.text ?? '',
  link: cta?.link ?? '',
});

export const toBaseSection: Mapper<any, SectionBase> = (c) => ({
  id: c?.id || v4(),
  bgColor: sectionColors[c?.colorIndex] || 'primaryColor',
  enabled: c?.enabled ?? false,
});

export const toServerCTA: Mapper<CTA, ServerCTA> = (s) => ({
  enabled: s.enabled,
  text: s.text || '',
  link: s.link || '',
});

export const toServerSections = <T extends SectionName>(
  sections: DomainSection<T>[],
) =>
  sections.map((s) =>
    sectionsConstructorMap[s.type].toServer(s),
  ) as ServerSection<T>[];

export const toDomainSections = <T extends SectionName>(
  serverSections: Array<ServerSection<T>>,
) =>
  serverSections
    .map(
      (s) => sectionsConstructorMap[s.type]?.toDomain(s) || null, // todo name mapping
    )
    .filter((s) => s !== null) as DomainSection<T>[];
